import React, { useEffect, useRef, useState } from 'react';
import { CustomHeader, Dot } from '@pages/new-design-components/custom-components';
import CustomSearch from '@pages/components/CustomSearch';
import { Col, Modal } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { ButtonContainer } from '@pages/reusable-components/styled-components';
import DebtManagementTable from '@pages/components/DebtManagement/DebtManagementTable';
import { GET_DEBT_QUOTES_REQUEST, UPDATE_DEBT_QUOTE_REQUEST } from '@redux/Customer/actions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import usePrevious from '@hooks/useprevious';
import notify from '@utils/notify';
import CustomDamageDropDown from "@pages/components/JobDetailsComponents/CustomDropDown";
import {fleetNewStatuses} from '@constants/index';

const statusOptions = fleetNewStatuses.quoteStatuses.map(status => ({
  key: status.key,
  name: status.title,
}));

export default function RepairQuotes() {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [orderFilter, setOrderFilter] = useState({});
  const [fetchingData, setFetchingData] = useState({});
  const [filter, setFilter] = useState({
    debt_status: '',
    status: null
  });
  const history = useHistory();
  const {
    getDebtQuotesSuccess,
    getDebtQuotesError,
    debtQuotes,
    updateQuoteSuccess,
    updateQuoteError,
  } = useSelector((state) => state.customer, shallowEqual);

  const getDebtQuotesSuccessPrev = usePrevious(getDebtQuotesSuccess);
  const getDebtQuotesErrorPrev = usePrevious(getDebtQuotesError);

  const updateQuoteSuccessPrev = usePrevious(updateQuoteSuccess);
  const updateQuoteErrorPrev = usePrevious(updateQuoteError);

  const keys = [
    {
      key: 'customer_name_deep',
      label: 'Customer',
    },

    {
      key: 'vehicle_deep',
      label: 'Vehicle & Reg Number',
    },
    {
      key: 'mobile_number_deep',
      label: 'Phone Number',
    },
    {
      key: 'created_at',
      label: 'Quote Sent Date',
      date: true,
      sort: true,
    },
    {
      key: 'status',
      label: 'Status',
      select: true,
      selectContainer: 'quoteStatuses',
    },
    {
      key: 'total',
      label: 'Total',
      sort: true,
    },
  ];
  const fetchData = (localFilter = {}) => {
    dispatch({
      type: GET_DEBT_QUOTES_REQUEST,
      payload: { ...localFilter },
    });
  };
  useEffect(() => {
    fetchData({ debt_status: '', status: null });
  }, []);

  useEffect(() => {
    if (getDebtQuotesSuccess && getDebtQuotesSuccessPrev === false) {
      setTableData(debtQuotes);
      setLoading(false);
    }
  }, [getDebtQuotesSuccess, getDebtQuotesSuccessPrev]);

  useEffect(() => {
    if (getDebtQuotesError && getDebtQuotesErrorPrev === false) {
      setLoading(false);
      notify.warning('Something went wrong while getting stats!');
    }
  }, [getDebtQuotesError, getDebtQuotesErrorPrev]);

  useEffect(() => {
    if (updateQuoteSuccess && updateQuoteSuccessPrev === false) {
      notify.success('Quote successfully updated!');
      setTableData((prevState) =>
        prevState.map((item) =>
          item.id === fetchingData.id ? { ...item, status: fetchingData.status } : item
        )
      );
      setFetchingData({});
      toggleModal();
    }
  }, [updateQuoteSuccess, updateQuoteSuccessPrev]);

  useEffect(() => {
    if (updateQuoteError && updateQuoteErrorPrev === false) {
      setFetchingData({});
      toggleModal();
      notify.warning('Something went wrong, please try again later.');
    }
  }, [updateQuoteError, updateQuoteErrorPrev]);

  const filterData = ({ key, value }) => {
    let tempFilter = { ...filter };
    tempFilter[key] = value;
    setFilter(tempFilter);
    fetchData(tempFilter);
  };

  const viewDetails = (index) => {
    const data = tableData[index];
    const queryParams = new URLSearchParams({
      customer_id: data.customer_id,
    }).toString();
    history.push({
      pathname: `/admin/customer-overview`,
      search: queryParams,
    });
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const setOrderItem = (data) => {
    setOrderFilter(data);
    let tempFilter = { ...filter, ...data };
    setFilter(tempFilter);
    fetchData(tempFilter);
  };
  const selectValue = (data) => {
    setFetchingData({
      id: data.id,
      [data.key]: data.value,
    });
    toggleModal();
  };
  const saveChanges = () => {
    dispatch({
      type: UPDATE_DEBT_QUOTE_REQUEST,
      payload: { ...fetchingData },
    });
  };
  const cancelEdit = () => {
    setFetchingData({});
    toggleModal();
  };
  return (
    <div className={'container-fluid debt-background pt-3'}>
      <Modal isOpen={showModal} toggle={toggleModal} className="modal-dialog-centered">
        <div className={'p-3'}>
          <h6 className="modal-title text-center">Are you sure?</h6>
        </div>

        <div className="modal-footer justify-content-between">
          <ButtonContainer reverse onClick={saveChanges}>
            {`Change Status`}
          </ButtonContainer>
          <ButtonContainer onClick={cancelEdit}>{`Cancel`}</ButtonContainer>
        </div>
      </Modal>
      <CustomHeader lineHeight={'unset'}>Repair Quotes</CustomHeader>

      <div className={'d-flex g-10 flex-wrap debt-datePicker white-background'}>
        <Col lg={2} sm={12} md={6}>
          <CustomSearch
            onChange={(e) => {
              filterData({ key: 'full_name', value: e.target.value });
            }}
            placeholder="Search"
          />
        </Col>
        <Col md={4}>
          <CustomDamageDropDown
            emptyTitle={'Status'}
            data={[{ name: '-' }, ...statusOptions]}
            labelKey={'name'}
            valueKey={'key'}
            selectedTitle={filter?.status}
            handleChange={(e) => {
              filterData({ key: 'status', value: e });
            }}
          />
        </Col>
      </div>
      <div className={'table-container table-bottom-space'}>
        <DebtManagementTable
          keys={keys}
          loading={loading}
          tableData={tableData}
          viewDetails={viewDetails}
          filter={orderFilter}
          setOrderItem={setOrderItem}
          selectValue={selectValue}
        />
      </div>
    </div>
  );
}
